import usePonyfill from './druid/providers/Ponyfill/usePonyfill';

export default usePonyfill;
